import {
  GET_FILTERS,
  GET_FILTERS_FAIL,
  GET_FILTERS_SUCCESS,
  APPLY_FILTER_PROPERTY,
  APPLY_FILTER_PROPERTY_FAIL,
  APPLY_FILTER_PROPERTY_SUCCESS,
  APPLY_FILTER_BLOCK,
  APPLY_FILTER_BLOCK_FAIL,
  APPLY_FILTER_BLOCK_SUCCESS,
  RESTORE_FILTER_PROPERTY
} from "./actionTypes"

export const getFilters = (uId) => ({
  type: GET_FILTERS,
  payload: uId,
})

export const getFiltersSuccess = filters => {
  return {
    type: GET_FILTERS_SUCCESS,
    payload: filters,
  };
}

export const getFiltersFail = error => ({
  type: GET_FILTERS_FAIL,
  payload: error,
})

export const applyFilterProperty = property => ({
  type: APPLY_FILTER_PROPERTY,
  payload: property,
})

export const applyFilterPropertySuccess = property => ({
  type: APPLY_FILTER_PROPERTY_SUCCESS,
  payload: property,
})

export const applyFilterPropertyFail = error => ({
  type: APPLY_FILTER_PROPERTY_FAIL,
  payload: error,
})

export const restoreFilterProperty = () => ({
  type: RESTORE_FILTER_PROPERTY,
  // payload: property,
})

export const applyFilterBlock = block => {
  return {
    type: APPLY_FILTER_BLOCK,
    payload: block,
  };
}

export const applyFilterBlockSuccess = block => ({
  type: APPLY_FILTER_BLOCK_SUCCESS,
  payload: block,
})

export const applyFilterBlockFail = error => ({
  type: APPLY_FILTER_BLOCK_FAIL,
  payload: error,
})
